import {Size} from 'amber-blocks/types';
import b_ from 'b_';
import React, {PropsWithChildren} from 'react';

import {Col, Row} from '#blocks/grid';
import {Gap} from '#blocks/types';
import './TaxiFormLayoutRow.styl';

const b = b_.with('TaxiFormLayoutRow');

interface Props {
    label?: React.ReactNode;
    valign?: 'start' | 'center' | 'end';
    size?: Size;
    required?: boolean;
    hint?: string | React.ReactNode;
    gap?: Gap;
}

const TaxiFormLayoutRow: React.FC<PropsWithChildren<Props>> = ({label, gap, size = false, hint, valign = 'center', required, children}) => (
    <Row
        gap={gap}
        className={b()}
        valign={valign !== 'start' ? valign : undefined}>
        {required && <Col gap="no" className={b('required', {valign: valign !== 'start' ? valign : false})}>*</Col>}
        {label && <Col className={b('label', {size})}>{label}</Col>}
        <Col className={b('control')}>
            {children}
            {hint && <Row gap="no" className={b('hint')}>{hint}</Row>}
        </Col>
    </Row>
);

export default React.memo(TaxiFormLayoutRow);
